import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[820px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/38c988784bf3979d74a907ab70844df5.jpg"
          alt="Calm interior living space"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/50" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/20 via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6 md:px-16 w-full">
        <p
          className="text-white/55 text-[10px] tracking-[0.5em] uppercase mb-7"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          A Visual Journal of Calm Interiors
        </p>

        <h1
          className="text-white text-5xl md:text-7xl lg:text-[88px] leading-[1.05] mb-7 max-w-4xl"
          style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
        >
          Calm interiors for<br />
          <em>slower, softer living</em>
        </h1>

        <p
          className="text-white/65 text-sm md:text-base max-w-lg leading-relaxed mb-12"
          style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
        >
          Discover peaceful living rooms, cozy corners, and warm minimalist home inspiration
          curated for quiet everyday spaces.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/style-guide"
            className="bg-white text-[#2C2825] px-9 py-3.5 rounded-full text-xs tracking-[0.18em] hover:bg-[#FAF7F0] transition-all duration-300 cursor-pointer whitespace-nowrap uppercase"
            style={{ fontFamily: "'Inter', sans-serif", fontWeight: 500 }}
          >
            Explore the Journal
          </Link>
          <Link
            to="/living-room"
            className="border border-white/60 text-white px-9 py-3.5 rounded-full text-xs tracking-[0.18em] hover:bg-white/10 hover:border-white transition-all duration-300 cursor-pointer whitespace-nowrap uppercase"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            View Living Rooms
          </Link>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <div className="w-px h-10 bg-white/30" />
        <p
          className="text-white/35 text-[9px] tracking-[0.4em] uppercase"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Scroll
        </p>
      </div>
    </section>
  );
}
